import React, { Component } from 'react';
import { Layout, Menu, Icon, Tag } from 'antd';
import { Link } from 'react-router-dom';
import routes from '../../routes';
import styles from './LeftSider.less';
import { Scrollbars } from 'react-custom-scrollbars';
import { connect } from 'react-redux';
import config from 'react-global-configuration';
import { FormattedMessage } from 'react-intl';

const { Sider } = Layout;
const { SubMenu, ItemGroup } = Menu;

class LeftSider extends Component {

    constructor(props) {
        super(props);

        let role = {
            itoneAdmin: false,
            wasteMgntAdmin: false,
            wasteMgntMaintainUser: false,
        }

        if (this.props.currentUser.permissions) {
            role = {
                itoneAdmin: this.props.currentUser.permissions.includes("IT One Admin"),
                wasteMgntAdmin: this.props.currentUser.permissions.includes("Waste Management Admin"),
                wasteMgntMaintainUser: this.props.currentUser.permissions.includes("Waste Management Maintain User"),
                PlanFouledAdmin: this.props.currentUser.permissions.includes("Plan Fouled Admin"),
                planSolventAdmin: this.props.currentUser.permissions.includes("Plan Solvent Admin")
            }
        }

        this.state = {
            userRole: role,
            openKeys: this.getDefaultOpenKeys(props),
            //openKeys: ['/request'],
            wasteApiBaseUrl: config.get("wasteApiBaseUrl"),
        };
    }

    rootSubmenuKeys = ['/request', '/worklist', '/master', '/configuration', '/report', '/management'];
    getDefaultSelectedMenus = () => {
        let paths = routes.map(r => r.path);
        let selectedMenus = paths.filter((path) => {
            return this.props.location.pathname.includes(path);
        });
        selectedMenus = this.fnFilterSelectedMenus(this.props.location.pathname, selectedMenus);
        return selectedMenus.length === 0 ? ["/home"] : selectedMenus;
    }

    fnFilterSelectedMenus = (originalPath, selectMenusList) => {
        let resultList = [];
        let originalList = originalPath.split('/');

        for (let item of selectMenusList) {
            let isFound = true;
            let itemSplitList = item.split('/');

            for (let valueSelected of itemSplitList) {
                let tmp = originalList.filter(item => item === valueSelected);
                if (tmp.length === 0) {
                    isFound = false;
                    break;
                }
            }

            if (isFound) {
                resultList.push(item);
            }
        }
        return resultList;
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.props.location !== nextProps.location) {
            this.setState({
                openKeys: this.getDefaultOpenKeys(nextProps),
            });
        }
    }

    // Todo: Improve logic
    getDefaultOpenKeys = (props) => {
        let keys = props.location.pathname.split('/')
        if (keys.length > 3) {
            return [("/" + keys[1]), ("/" + keys[1] + "/" + keys[2])];
        }
        return [("/" + keys[1])];
    }

    onOpenChange = (openKeys) => {
        const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            if (openKeys.length > 2) {
                let setOpenKey = openKeys;
                setOpenKey = [setOpenKey[0], latestOpenKey];
                this.setState({
                    openKeys: setOpenKey,
                });
            } else {
                this.setState({ openKeys });
            }
        }
        else {
            this.setState({
                openKeys: latestOpenKey ? [latestOpenKey] : [],
            });
        }
    }

    render() {
        return (
            <Sider
                trigger={null}
                collapsible
                collapsed={this.props.collapsed}
                width={256}
                theme="dark"
                mode="inline"
                style={{ zIndex: 10, position: 'fixed', minHeight: '100vh' }}
            >
                {/*<div style={{ margin: '8', padding: '5px', textAlign: 'center' }}>
                    <img src="//smartwork.scg.co.th/cdn/images/logo/scg-logo250x100.png" style={{ width: '50%' }} />
                </div>*/}
                <div className="logo" id="logo" style={{ textAlign: 'center' }}>
                    <Link to="/">
                        {!this.props.collapsed ? <h1>Waste Management</h1> : <h1>W</h1>}
                    </Link>
                </div>
                {/*<div style={{ overflowY: 'auto', ...this.getMaxHeightStyle()}}>*/}
                <Scrollbars
                    style={{ width: '100%' }}
                    autoHeight
                    autoHeightMin={'calc(100vh - 64px)'}
                    autoHeightMax={'calc(100vh - 64px)'}
                    autoHide
                    autoHideTimeout={500}
                    autoHideDuration={500}>
                    <Menu key="Menu" theme="dark" mode="inline"
                        defaultSelectedKeys={this.getDefaultSelectedMenus()}
                        selectedKeys={this.getDefaultSelectedMenus()}
                        defaultOpenKeys={this.getDefaultOpenKeys(this.props)}
                        //openKeys={this.getDefaultOpenKeys() == "/home" ? this.getDefaultOpenKeys(): this.state.openKeys}
                        openKeys={this.state.openKeys}
                        onOpenChange={this.onOpenChange}
                    >
                        <Menu.Item key="/home">
                            <Link to="/home">
                                <Icon type="home" />
                                <FormattedMessage
                                    id="leftSider.Home"
                                    defaultMessage="Home"
                                />
                            </Link>
                        </Menu.Item>
                        {//this.state.userRole.wasteMgntMaintainUser ? null :
                            <SubMenu key="/request" title={<span><Icon type="form" /><FormattedMessage
                                id="leftSider.Request"
                                defaultMessage="Request"
                            /></span>}>
                                <Menu.Item key="/request/waste-slip">
                                    <Link to={{
                                        pathname: '/request/waste-slip',
                                        search: ''
                                    }}>
                                        <FormattedMessage
                                            id="leftSider.WasteSlip"
                                            defaultMessage="Waste Slip"
                                        />
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="/request/survey-by-observer">
                                    <Link to={{
                                        pathname: '/request/survey-by-observer',
                                        search: ''
                                    }}>
                                        <FormattedMessage
                                            id="leftSider.SurveyByObserver"
                                            defaultMessage="Survey By Observer"
                                        />
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="/request/weight-license">
                                    <Link to={{
                                        pathname: '/request/weight-license',
                                        search: ''
                                    }}>
                                        <FormattedMessage
                                            id="leftSider.WeightLicense"
                                            defaultMessage="Weight License"
                                        />
                                    </Link>
                                </Menu.Item>
                                <SubMenu key="/request/fouled" title={<span><FormattedMessage
                                    id="leftSider.Fouled"
                                    defaultMessage="Fouled"
                                /></span>}>
                                    <Menu.Item key="/request/fouled/planFouled">
                                        <Link to={{
                                            pathname: '/request/fouled/planFouled',
                                            search: ''
                                        }}>
                                            <FormattedMessage
                                                id="leftSider.PlanFouled"
                                                defaultMessage="Plan Fouled"
                                            />
                                        </Link>
                                    </Menu.Item>
                                    <Menu.Item key="/request/fouled/receiveFouled">
                                        <Link to={{
                                            pathname: '/request/fouled/receiveFouled',
                                            search: ''
                                        }}>
                                            <FormattedMessage
                                                id="leftSider.ReceiveFouled"
                                                defaultMessage="Receive Fouled"
                                            />
                                        </Link>
                                    </Menu.Item>
                                </SubMenu>
                                <SubMenu key="/request/solvent" title={<span><FormattedMessage
                                    id="leftSider.Solvent"
                                    defaultMessage="Solvent"
                                /></span>}>
                                    <Menu.Item key="/request/solvent/plantSolvent">
                                        <Link to={{
                                            pathname: '/request/solvent/plantSolvent',
                                            search: ''
                                        }}>
                                            <FormattedMessage
                                                id="leftSider.PlantSolvent"
                                                defaultMessage="Plan Solvent"
                                            />
                                        </Link>
                                    </Menu.Item>
                                    <Menu.Item key="/request/solvent/revisePlanSolvent">
                                        <Link to={{
                                            pathname: '/request/solvent/revisePlanSolvent',
                                            search: ''
                                        }}>
                                            <FormattedMessage
                                                id="leftSider.RevisePlanSolvent"
                                                defaultMessage="Revise Plan Solvent"
                                            />
                                        </Link>
                                    </Menu.Item>
                                    <Menu.Item key="/request/solvent/planningCheck">
                                        <Link to={{
                                            pathname: '/request/solvent/planningCheck',
                                            search: ''
                                        }}>
                                            <FormattedMessage
                                                id="leftSider.PlanningCheck"
                                                defaultMessage="Planning Check"
                                            />
                                        </Link>
                                    </Menu.Item>
                                    <Menu.Item key="/request/solvent/receiveSolvent">
                                        <Link to={{
                                            pathname: '/request/solvent/receiveSolvent',
                                            search: ''
                                        }}>
                                            <FormattedMessage
                                                id="leftSider.ReceiveSolvent"
                                                defaultMessage="Receive Solvent"
                                            />
                                        </Link>
                                    </Menu.Item>
                                </SubMenu>
                            </SubMenu>
                        }
                        <SubMenu key="/worklist" title={<span><Icon type="bars" />
                            <FormattedMessage
                                id="leftSider.Worklist"
                                defaultMessage="Worklist"
                            /></span>}>
                            <Menu.Item key="/worklist/waste-slip/myTask" >
                                <Link to="/worklist/waste-slip/myTask">
                                    <FormattedMessage
                                        id="leftSider.MyTask"
                                        defaultMessage="My Task"
                                    />
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/worklist/waste-slip/myRequest">
                                <Link to="/worklist/waste-slip/myRequest">
                                    <FormattedMessage
                                        id="leftSider.MyWasteSlipRequest"
                                        defaultMessage="My Waste Slip Request"
                                    />
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/worklist/survey-by-observer/myRequest">
                                <Link to="/worklist/survey-by-observer/myRequest">
                                    <FormattedMessage
                                        id="leftSider.MySurveyByObserverRequest"
                                        defaultMessage="My Survey By Observer Request"
                                    />
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/worklist/weight-license/myRequest">
                                <Link to="/worklist/weight-license/myRequest">
                                    <FormattedMessage
                                        id="leftSider.MyWeightLicenseRequest"
                                        defaultMessage="My Weight License Request"
                                    />
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/worklist/receiveFouled/myRequest">
                                <Link to="/worklist/receiveFouled/myRequest">
                                    <FormattedMessage
                                        id="leftSider.MyReceiveFouledRequest"
                                        defaultMessage="My Receive Fouled Request"
                                    />
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/worklist/receiveSolvent/myRequest">
                                <Link to="/worklist/receiveSolvent/myRequest">
                                    <FormattedMessage
                                        id="leftSider.MyReceiveSolventRequest"
                                        defaultMessage="My Receive Solvent Request"
                                    />
                                </Link>
                            </Menu.Item>
                        </SubMenu>
                        {(this.state.userRole.itoneAdmin || this.state.userRole.wasteMgntAdmin || this.state.userRole.PlanFouledAdmin || this.state.userRole.planSolventAdmin) ?
                            <SubMenu key="/master" title={<span><Icon type="database" /><FormattedMessage
                                id="leftSider.MasterData"
                                defaultMessage="Master Data"
                            /></span>}>
                                {this.state.userRole.wasteMgntAdmin || this.state.userRole.itoneAdmin ?
                                    <SubMenu key="/master/wasteMgnt" title={<span><FormattedMessage
                                        id="leftSider.WasteManagement"
                                        defaultMessage="Waste Management"
                                    /></span>}>
                                        <Menu.Item key="/master/wasteMgnt/company">
                                            <Link to="/master/wasteMgnt/company">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Company"
                                                    defaultMessage="Company"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/wasteMgnt/unit">
                                            <Link to="/master/wasteMgnt/unit">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Unit"
                                                    defaultMessage="Unit"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/wasteMgnt/material">
                                            <Link to="/master/wasteMgnt/material">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Material"
                                                    defaultMessage="Material"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/wasteMgnt/site">
                                            <Link to="/master/wasteMgnt/site">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Site"
                                                    defaultMessage="Site"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/wasteMgnt/plant">
                                            <Link to="/master/wasteMgnt/plant">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Plant"
                                                    defaultMessage="Plant"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/wasteMgnt/unitPrice">
                                            <Link to="/master/wasteMgnt/unitPrice">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.UnitPrice"
                                                    defaultMessage="Unit Price"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/wasteMgnt/packaging">
                                            <Link to="/master/wasteMgnt/packaging">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.packaging"
                                                    defaultMessage="Packaging"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        {this.state.userRole.itoneAdmin ?
                                            <Menu.Item key="/master/wasteMgnt/typeOfLocation">
                                                <Link to="/master/wasteMgnt/typeOfLocation">
                                                    <FormattedMessage
                                                        id="leftSider.MasterData.TypeOfLocation"
                                                        defaultMessage="Type Of Location"
                                                    />
                                                </Link>
                                            </Menu.Item> : null
                                        }
                                        <Menu.Item key="/master/wasteMgnt/location">
                                            <Link to="/master/wasteMgnt/location">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Location"
                                                    defaultMessage="Location"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        {1 === 0 ?
                                            <Menu.Item key="/master/transport">
                                                <Link to="/master/transport">
                                                    <FormattedMessage
                                                        id="leftSider.MasterData.Transport"
                                                        defaultMessage="Transport"
                                                    />
                                                </Link>
                                            </Menu.Item>
                                            :
                                            null
                                        }
                                        <Menu.Item key="/master/wasteMgnt/businessPartner">
                                            <Link to="/master/wasteMgnt/businessPartner">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.BusinessPartner"
                                                    defaultMessage="Business Partner"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/wasteMgnt/roleResponsible">
                                            <Link to={{
                                                pathname: '/master/wasteMgnt/roleResponsible',
                                                search: 'workflowName=Waste Management'
                                            }}>
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Role"
                                                    defaultMessage="Role & Responsible"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/wasteMgnt/Evaluation">
                                            <Link to={{
                                                pathname: '/master/wasteMgnt/Evaluation',
                                                search: 'workflowName=Waste Management'
                                            }}>
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Evaluation"
                                                    defaultMessage="Evaluation"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        {(this.state.userRole.itoneAdmin) ?
                                            <Menu.Item key="/master/wasteMgnt/user">
                                                <Link to="/master/wasteMgnt/user">
                                                    <FormattedMessage
                                                        id="leftSider.MasterData.Contractor"
                                                        defaultMessage="Contractor"
                                                    />
                                                </Link>
                                            </Menu.Item>
                                            : null}

                                        <Menu.Item key="/master/wasteMgnt/paymentMethod">
                                            <Link to="/master/wasteMgnt/paymentMethod">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.PaymentMethod"
                                                    defaultMessage="Payment Method"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/wasteMgnt/diwCode">
                                            <Link to="/master/wasteMgnt/diwCode">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.DIWCode"
                                                    defaultMessage="DIW Code"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/wasteMgnt/materialCodeGroup">
                                            <Link to="/master/wasteMgnt/materialCodeGroup">
                                                <FormattedMessage
                                                    id="leftSider.MaterialCodeGroup"
                                                    defaultMessage="Material Code Group"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/wasteMgnt/biddingContract">
                                            <Link to="/master/wasteMgnt/biddingContract">
                                                <FormattedMessage
                                                    id="leftSider.BiddingContract"
                                                    defaultMessage="Bidding Contract"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/wasteMgnt/foreman">
                                            <Link to="/master/wasteMgnt/foreman">
                                                <FormattedMessage
                                                    id="leftSider.Foreman"
                                                    defaultMessage="Foreman"
                                                />
                                            </Link>
                                        </Menu.Item>
                                    </SubMenu>
                                    : null
                                }

                                {/* plan Solvent */}
                                {(this.state.userRole.planSolventAdmin || this.state.userRole.itoneAdmin) ?
                                    <SubMenu key="/master/planSolvent" title={<span><FormattedMessage
                                        id="leftSider.MasterData.PlanSolvent"
                                        defaultMessage="Plan Solvent"
                                    /></span>}>
                                        <Menu.Item key="/master/planSolvent/chemical">
                                            <Link to="/master/planSolvent/chemical">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.chemical"
                                                    defaultMessage="Chemical"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/planSolvent/chemicalDensity">
                                            <Link to="/master/planSolvent/chemicalDensity">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.ChemicalDensity"
                                                    defaultMessage="Chemical Density"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/planSolvent/chemicalQuota">
                                            <Link to="/master/planSolvent/chemicalQuota">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.ChemicalQuota"
                                                    defaultMessage="Chemical Quota"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/planSolvent/plant">
                                            <Link to="/master/planSolvent/plant">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Plant"
                                                    defaultMessage="Plant"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/planSolvent/planPlant">
                                            <Link to="/master/planSolvent/planPlant">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.PlanPlant"
                                                    defaultMessage="Plan Plant"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/planSolvent/plantController">
                                            <Link to="/master/planSolvent/plantController">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.PlantController"
                                                    defaultMessage="Plant Controller"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/planSolvent/vendor">
                                            <Link to="/master/planSolvent/vendor">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Vendor"
                                                    defaultMessage="Vendor"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/planSolvent/roleResponsible">
                                            <Link to={{
                                                pathname: '/master/planSolvent/roleResponsible',
                                                search: 'workflowName=Plan Solvent'
                                            }}>
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Role"
                                                    defaultMessage="Role & Responsible"
                                                />
                                            </Link>
                                        </Menu.Item>
                                    </SubMenu>
                                    : null}

                                {/* plan Fouled */}
                                {(this.state.userRole.PlanFouledAdmin || this.state.userRole.itoneAdmin) ?
                                    <SubMenu key="/master/planFouled" title={<span><FormattedMessage
                                        id="leftSider.MasterData.PlanFouled"
                                        defaultMessage="Plan Fouled"
                                    /></span>}>
                                        <Menu.Item key="/master/planFouled/chemical">
                                            <Link to="/master/planFouled/chemical">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.chemical"
                                                    defaultMessage="Chemical"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/planFouled/vendor">
                                            <Link to="/master/planFouled/vendor">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Vendor"
                                                    defaultMessage="Vendor"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/planFouled/density">
                                            <Link to="/master/planFouled/density">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Density"
                                                    defaultMessage="Density"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/planFouled/foulPrice">
                                            <Link to="/master/planFouled/foulPrice">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.FoulPrice"
                                                    defaultMessage="Foul Price"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/planFouled/plant">
                                            <Link to="/master/planFouled/plant">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Plant"
                                                    defaultMessage="Plant"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/planFouled/planPlant">
                                            <Link to="/master/planFouled/planPlant">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.PlanPlant"
                                                    defaultMessage="Plan Plant"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/planFouled/plantController">
                                            <Link to="/master/planFouled/plantController">
                                                <FormattedMessage
                                                    id="leftSider.MasterData.PlantController"
                                                    defaultMessage="Plant Controller"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        <Menu.Item key="/master/planFouled/roleResponsible">
                                            <Link to={{
                                                pathname: '/master/planFouled/roleResponsible',
                                                search: 'workflowName=Plan Fouled'
                                            }}>
                                                <FormattedMessage
                                                    id="leftSider.MasterData.Role"
                                                    defaultMessage="Role & Responsible"
                                                />
                                            </Link>
                                        </Menu.Item>

                                    </SubMenu>
                                    : null}
                            </SubMenu>
                            : null}
                        <SubMenu key="/report" title={<span><Icon type="bar-chart" /><FormattedMessage
                            id="leftSider.Report"
                            defaultMessage="Report"
                        /></span>}>
                            <Menu.Item key="/report/report90Day">
                                <Link to="/report/report90Day">
                                    <FormattedMessage
                                        id="leftSider.Report.90Day"
                                        defaultMessage="90 Days Report"
                                    />
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/report90DayWriteOff">
                                <Link to="/report/report90DayWriteOff">
                                    <FormattedMessage
                                        id="leftSider.Report.90DayWriteOff"
                                        defaultMessage="90 Days Report WriteOff"
                                    />
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/reportPlanForWaste">
                                <Link to="/report/reportPlanForWaste">
                                    <FormattedMessage
                                        id="leftSider.Report.PlanForWaete"
                                        defaultMessage="Plan For Waste Report"
                                    /><span></span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/reportFouledGR">
                                <Link to="/report/reportFouledGR">
                                    <FormattedMessage
                                        id="leftSider.Report.FouledGRReport"
                                        defaultMessage="Fouled GR Report"
                                    /><span></span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/reportDIW">
                                <Link to="/report/reportDIW">
                                    <FormattedMessage
                                        id="leftSider.Report.reportDIW"
                                        defaultMessage="DIW Report"
                                    /><span></span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/reportSolventGR">
                                <Link to="/report/reportSolventGR">
                                    <FormattedMessage
                                        id="leftSider.Report.reportSolventGR"
                                        defaultMessage="Solvent GR Report"
                                    /><span></span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/reportWeightLicense">
                                <Link to="/report/reportWeightLicense">
                                    <FormattedMessage
                                        id="leftSider.Report.reportWeightLicense"
                                        defaultMessage="รายงานลงกรม"
                                    /><span></span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/reportEvaluation">
                                <Link to="/report/reportEvaluation">
                                    <FormattedMessage
                                        id="leftSider.Report.ReportEvaluation"
                                        defaultMessage="Evaluation Report"
                                    /><span></span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/reportAutoWeight">
                                <Link to="/report/reportAutoWeight">
                                    <FormattedMessage
                                        id="leftSider.Report.ReportAutoWeight"
                                        defaultMessage="Auto Weight Report"
                                    /><span></span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item key="/report/reportWMS">
                                <Link to="/report/reportWMS">
                                    <FormattedMessage
                                        id="leftSider.Report.ReportWMS"
                                        defaultMessage="Waste Management Report"
                                    /><span></span>
                                </Link>
                            </Menu.Item>
                        </SubMenu>

                        {(this.state.userRole.itoneAdmin) ?
                            <SubMenu key="/management" title={<span><Icon type="tool" /><FormattedMessage
                                id="leftSider.Management"
                                defaultMessage="Management"
                            /><span></span></span>}>
                                <SubMenu key="/management/redirect" title={<span><FormattedMessage
                                    id="leftSider.Redirect"
                                    defaultMessage="Redirect"
                                /></span>}>
                                    <Menu.Item key="/management/redirect/wasteSlip">
                                        <Link to="/management/redirect/wasteSlip">
                                            <FormattedMessage
                                                id="leftSider.Redirect.WasteSlip"
                                                defaultMessage="WasteSlip"
                                            />
                                        </Link>
                                    </Menu.Item>
                                    <Menu.Item key="/management/redirect/weightLicense">
                                        <Link to="/management/redirect/weightLicense">
                                            <FormattedMessage
                                                id="leftSider.Redirect.WeightLicense"
                                                defaultMessage="Weight License"
                                            />
                                        </Link>
                                    </Menu.Item>
                                    <Menu.Item key="/management/redirect/receiveSolvent">
                                        <Link to="/management/redirect/receiveSolvent">
                                            <FormattedMessage
                                                id="leftSider.Redirect.ReceiveSolvent"
                                                defaultMessage="Receive Solvent"
                                            />
                                        </Link>
                                    </Menu.Item>
                                </SubMenu>
                                <Menu.Item key="/management/indexContent">
                                    <Link to="/management/indexContent">
                                        <FormattedMessage
                                            id="leftSider.Management.HomeContent"
                                            defaultMessage="Home Content"
                                        />
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="/management/planFouledContent">
                                    <Link to={{
                                        pathname: '/management/planFouledContent',
                                        search: 'workflowName=Plan Fouled'
                                    }}>
                                        <FormattedMessage
                                            id="leftSider.Management.PlanFouledContent"
                                            defaultMessage="Plan Fouled Content"
                                        />
                                    </Link>
                                </Menu.Item>
                                {/**
                                <Menu.Item key="/management/wasteTSAConfig">
                                    <Link to={{
                                        pathname: '/management/wasteTSAConfig',
                                        search: 'workflowName=Waste Management'
                                    }}>
                                        <FormattedMessage
                                            id="leftSider.Management.wasteTSAConfig"
                                            defaultMessage="Waste TSA Config"
                                        />
                                    </Link>
                                </Menu.Item>
                                **/}
                                <Menu.Item key="/management/planSolventTSAConfig">
                                    <Link to={{
                                        pathname: '/management/planSolventTSAConfig',
                                        search: 'workflowName=Plan Solvent'
                                    }}>
                                        <FormattedMessage
                                            id="leftSider.Management.planSolventTSAConfig"
                                            defaultMessage="Plan Solvent TSA Config"
                                        />
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="/management/planFouledTSAConfig">
                                    <Link to={{
                                        pathname: '/management/planFouledTSAConfig',
                                        search: 'workflowName=Plan Fouled'
                                    }}>
                                        <FormattedMessage
                                            id="leftSider.Management.planFouledTSAConfig"
                                            defaultMessage="Plan Fouled TSA Config"
                                        />
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="/management/ContentTranslate">
                                    <Link to="/management/ContentTranslate">
                                        Content Translate
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="/management/configuration">
                                    <Link to="/management/configuration">
                                        <FormattedMessage
                                            id="leftSider.Management.Configuration"
                                            defaultMessage="Configuration"
                                        />
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="/management/systemLogs">
                                    <Link to="/management/systemLogs">
                                        <FormattedMessage
                                            id="leftSider.Management.SystemLogs"
                                            defaultMessage="System Logs"
                                        />
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="/management/roleResponsible">
                                    <Link to={{
                                        pathname: '/management/roleResponsible',
                                        search: 'workflowName=IT One Admin'
                                    }}>
                                        <FormattedMessage
                                            id="leftSider.MasterData.Role"
                                            defaultMessage="Role & Responsible"
                                        />
                                    </Link>
                                </Menu.Item>
                            </SubMenu> :

                            (this.state.userRole.PlanFouledAdmin || this.state.userRole.wasteMgntAdmin || this.state.userRole.planSolventAdmin) ?
                                <SubMenu key="/management" title={<span><Icon type="tool" /><FormattedMessage
                                    id="leftSider.Management"
                                    defaultMessage="Management"
                                /></span>}>
                                    {this.state.userRole.wasteMgntAdmin || this.state.userRole.planSolventAdmin ?
                                        <SubMenu key="/management/redirect" title={<span><FormattedMessage
                                            id="leftSider.Redirect"
                                            defaultMessage="Redirect"
                                        /></span>}>
                                            {this.state.userRole.wasteMgntAdmin ? 
                                                <Menu.Item key="/management/redirect/wasteSlip">
                                                    <Link to="/management/redirect/wasteSlip">
                                                        <FormattedMessage
                                                            id="leftSider.Redirect.WasteSlip"
                                                            defaultMessage="WasteSlip"
                                                        />
                                                    </Link>
                                                </Menu.Item>
                                                : null
                                            }
                                            {this.state.userRole.wasteMgntAdmin ?
                                                <Menu.Item key="/management/redirect/weightLicense">
                                                    <Link to="/management/redirect/weightLicense">
                                                        <FormattedMessage
                                                            id="leftSider.Redirect.WeightLicense"
                                                            defaultMessage="Weight License"
                                                        />
                                                    </Link>
                                                </Menu.Item>
                                                : null
                                            }
                                            {this.state.userRole.planSolventAdmin ?
                                                <Menu.Item key="/management/redirect/receiveSolvent">
                                                    <Link to="/management/redirect/receiveSolvent">
                                                        <FormattedMessage
                                                            id="leftSider.Redirect.ReceiveSolvent"
                                                            defaultMessage="Receive Solvent"
                                                        />
                                                    </Link>
                                                </Menu.Item>
                                                : null
                                            }
                                        </SubMenu>
                                        : null
                                    }
                                    <Menu.Item key="/management/indexContent">
                                        <Link to="/management/indexContent">
                                            <FormattedMessage
                                                id="leftSider.Management.HomeContent"
                                                defaultMessage="Home Content"
                                            />
                                        </Link>
                                    </Menu.Item>
                                    {this.state.userRole.PlanFouledAdmin ?
                                        <Menu.Item key="/management/PlanFouledContent">
                                            <Link to={{
                                                pathname: '/management/PlanFouledContent',
                                                search: 'workflowName=Plan Fouled'
                                            }}>
                                                <FormattedMessage
                                                    id="leftSider.Management.PlanFouledContent"
                                                    defaultMessage="Plan Fouled Content"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        : null
                                    }
                                    {/**this.state.userRole.wasteMgntAdmin ?
                                        <Menu.Item key="/management/wasteTSAConfig">
                                            <Link to={{
                                                pathname: '/management/wasteTSAConfig',
                                                search: 'workflowName=Waste Management'
                                            }}>
                                                <FormattedMessage
                                                    id="leftSider.Management.wasteTSAConfig"
                                                    defaultMessage="Waste TSA Config"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        : null
                                    **/}
                                    {this.state.userRole.planSolventAdmin ?
                                        <Menu.Item key="/management/planSolventTSAConfig">
                                            <Link to={{
                                                pathname: '/management/planSolventTSAConfig',
                                                search: 'workflowName=Plan Solvent'
                                            }}>
                                                <FormattedMessage
                                                    id="leftSider.Management.planSolventTSAConfig"
                                                    defaultMessage="Plan Solvent TSA Config"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        : null
                                    }
                                    {this.state.userRole.PlanFouledAdmin ?
                                        <Menu.Item key="/management/planFouledTSAConfig">
                                            <Link to={{
                                                pathname: '/management/planFouledTSAConfig',
                                                search: 'workflowName=Plan Fouled'
                                            }}>
                                                <FormattedMessage
                                                    id="leftSider.Management.planFouledTSAConfig"
                                                    defaultMessage="Plan Fouled TSA Config"
                                                />
                                            </Link>
                                        </Menu.Item>
                                        : null
                                    }
                                </SubMenu>
                                : null
                        }
                        <Menu.Item key="/qrCode">
                            <Link to="/qrCode">
                                <Icon type="qrcode" /><FormattedMessage
                                    id="leftSider.QRCode"
                                    defaultMessage="Scan QR Code "
                                />
                            </Link>
                        </Menu.Item>
                    </Menu>
                </Scrollbars>
            </Sider >
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.CurrentUser.currentUser,
        language: state.LanguageSwitcher.language,
    }
}

export default connect(mapStateToProps, null)(LeftSider);
